;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof self?self:{},n=(new e.Error).stack;n&&(e._sentryDebugIds=e._sentryDebugIds||{},e._sentryDebugIds[n]="12ea4883-9f21-4c7d-9eec-69739e15263a",e._sentryDebugIdIdentifier="sentry-dbid-12ea4883-9f21-4c7d-9eec-69739e15263a")}catch(e){}}();import '../_virtual/_sentry-release-injection-file.js';

var SearchSuggestionToggleEnum;
(function (SearchSuggestionToggleEnum) {
    SearchSuggestionToggleEnum["SHOWN"] = "shown";
    SearchSuggestionToggleEnum["HIDDEN"] = "hidden";
})(SearchSuggestionToggleEnum || (SearchSuggestionToggleEnum = {}));
function createHeaderSearchDataLayerEvent(suggestionToggle) {
    return new CustomEvent('onHeaderSearchSuggestionFlyoutToggle', {
        detail: suggestionToggle,
    });
}
function dispatchSearchSuggestionStatusEvent(suggestionToggle) {
    const event = createHeaderSearchDataLayerEvent(suggestionToggle);
    window.dispatchEvent(event);
}

export { SearchSuggestionToggleEnum, createHeaderSearchDataLayerEvent, dispatchSearchSuggestionStatusEvent };
//# sourceMappingURL=index.js.map
